module.exports = __webpack_public_path__ + "static/media/check.90b26e1d.png";